import type { PoiContentSlide } from '@/types/shop';
import { getPoiDetailImageUrl } from './poiImage';
import { type PoiDetailProps } from '@/enums';
import type { FacilityPoiDetailProps } from '@/types/facility';
export const formatPoiSlideToDetail = (poiContent: PoiContentSlide | null, language: string): PoiDetailProps | null => {
    if (!poiContent) {
        return null;
    }

    const contents = poiContent.data.managedContents;
    const floorName = poiContent.floor;
    const buildingName = poiContent.buildingName;

    const imgUrlDetail = getPoiDetailImageUrl(contents, language);

    const shopCntcContent = contents?.find((item) => item.field_key === 'shopCntc')?.content;

    const shopCntc = shopCntcContent?.[language] || shopCntcContent?.ko || '';

    const categoryName = poiContent?.categoryName || poiContent?.category?.name;

    return {
        imgUrlDetail,
        floorName,
        buildingName,
        poiName: poiContent.name,
        shopCntc: shopCntc,
        categoryName: categoryName || '',
    };
};


export const formatPoiFacilitySlideToDetail = (poiContent: PoiContentSlide | null, language: string, showBuildingAddress?: boolean): FacilityPoiDetailProps | null => {
    if (!poiContent) {
        return null;
    }

    const contents = poiContent.data.managedContents;
    const floorName = poiContent.floor;
    const buildingName = poiContent.buildingName;

    const poiImage = getPoiDetailImageUrl(contents, language);

    const phoneCandidates = contents?.find((item) => item.field_key === 'shopCntc')?.content;

    const phoneNumber = phoneCandidates?.[language] || phoneCandidates?.ko || '';

    const description = contents?.find((item) => item.field_key === 'shopIntrdn')?.content[language] || poiContent.data.contents?.shopIntrdn?.[language] || poiContent.data.contents?.shopIntrdn?.['ko'] || '';

    return {
        poiImage,
        floorName,
        buildingAddress: buildingName,
        showBuildingAddress: !!showBuildingAddress,
        poiName: poiContent.name,
        phoneNumber,
        description
    };
};
